import { useEffect, useRef } from 'react';
import { useSearchParams } from 'react-router-dom';

export default function usePersistColumns(storageKey, keys) {
  const [searchParams, setSearchParams] = useSearchParams();
  const restoredRef = useRef(false);

  // --- Restore on first load ---
  useEffect(() => {
    if (restoredRef.current) return;

    const saved = sessionStorage.getItem(storageKey);
    if (!saved) {
      restoredRef.current = true;
      return;
    }

    let savedObj;
    try {
      savedObj = JSON.parse(saved);
    } catch {
      restoredRef.current = true;
      return;
    }

    const params = new URLSearchParams(searchParams);
    let changed = false;

    keys.forEach(key => {
      if (!params.has(key) && savedObj[key]) {
        params.set(key, savedObj[key]);
        changed = true;
      }
    });

    if (changed) {
      setSearchParams(params, { replace: true });
    } else {
      restoredRef.current = true;
    }
  }, [keys, searchParams, setSearchParams, storageKey]);

  // --- Save whenever these params change ---
  useEffect(() => {
    if (!restoredRef.current) return;

    const toSave = {};
    keys.forEach(key => {
      toSave[key] = searchParams.get(key) || '';
    });

    sessionStorage.setItem(storageKey, JSON.stringify(toSave));
  }, [keys, searchParams, storageKey]);
}
